import * as yup from 'yup';

export const ChildSupportDeductionInputs = {
    ASSIGNED_EMPLOYEE: "assigned_employee",
    DESCRIPTION: "description",
    START_DATE: "start_date",
    END_DATE: "end_date",
    DEDUCTION_AMOUNT: "deduction_amount",
    DEDUCTION_GAP: "deduction_gap",
    
    // CHILD SUPPORT INFO
    CASE: "case",
    FIPS_CODE: "fips_code",
    AGENCY: "agency",
    ISSUE_DATE: "issue_date",
    PAYMENT_AMOUNT: "payment_amount",
    MAX_PERCENTAGE: "max_percentage",
}

export const childSupportDeductionSchema = yup.object({
    [ChildSupportDeductionInputs.ASSIGNED_EMPLOYEE]: yup.string().required('This is required'),
    [ChildSupportDeductionInputs.DESCRIPTION]: yup.string().required('This is required'),
    [ChildSupportDeductionInputs.START_DATE]: yup.date().required('This is required'),
    [ChildSupportDeductionInputs.END_DATE]: yup.date().required('This is required'),
    [ChildSupportDeductionInputs.DEDUCTION_AMOUNT]: yup.string().required('This is required'),
    [ChildSupportDeductionInputs.DEDUCTION_GAP]: yup.string().required('This is required'),
    
    // CHILD SUPPORT INFO
    [ChildSupportDeductionInputs.CASE]: yup.string().required('This is required'),
    [ChildSupportDeductionInputs.FIPS_CODE]: yup.string().required('This is required'),
    [ChildSupportDeductionInputs.AGENCY]: yup.string().required('This is required'),
    [ChildSupportDeductionInputs.ISSUE_DATE]: yup.date().required('This is required'),
    [ChildSupportDeductionInputs.PAYMENT_AMOUNT]: yup.string().required('This is required'),
    [ChildSupportDeductionInputs.MAX_PERCENTAGE]: yup.string().required('This is required'),
});

export const MCNDeductionInputs = {
    ASSIGNED_EMPLOYEE: "assigned_employee",
    DESCRIPTION: "description",
    START_DATE: "start_date",
    END_DATE: "end_date",
    DEDUCTION_AMOUNT: "deduction_amount",
    DEDUCTION_GAP: "deduction_gap"
}

export const mcnDeductionSchema = yup.object({
    [MCNDeductionInputs.ASSIGNED_EMPLOYEE]: yup.string().required('This is required'),
    [MCNDeductionInputs.DESCRIPTION]: yup.string().required('This is required'),
    [MCNDeductionInputs.START_DATE]: yup.date().required('This is required'),
    [MCNDeductionInputs.END_DATE]: yup.date().required('This is required'),
    [MCNDeductionInputs.DEDUCTION_AMOUNT]: yup.string().required('This is required'),
    [MCNDeductionInputs.DEDUCTION_GAP]: yup.string().required('This is required'),
});